// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  projectId: __t.string().name("project_id"),
  orgId: __t.string().name("org_id"),
  round: __t.u32(),
  userId: __t.string().name("user_id"),
  name: __t.string(),
  decision: __t.string(),
  note: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  jobId: __t.string().name("job_id"),
  scopeId: __t.string().name("scope_id"),
  assetId: __t.string().name("asset_id"),
  linkId: __t.string().name("link_id"),
});
